// SHA-256 вмісту файлу (hex) через Web Crypto: за хешем сервер розпізнає
// повторне завантаження того самого файлу. Сам файл нікуди не надсилається.
export async function sha256Hex(buffer) {
  const subtle = window.crypto?.subtle;
  if (!subtle) throw new Error("crypto.subtle недоступний (потрібне безпечне з'єднання HTTPS)");
  const digest = await subtle.digest("SHA-256", buffer);
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
}
